import { ProductBlocksCollapsible_tab } from "_types";
import { Accordion } from "accordion";
import { ReactProductState } from "product";
import React, { FC } from "react";
import { StoreApi, UseBoundStore } from "zustand";

export const ProductCollapsibleTab: FC<{
  settings: ProductBlocksCollapsible_tab["settings"];
  useProduct: UseBoundStore<StoreApi<ReactProductState>>;
}> = ({ settings, useProduct }) => {
  const { product } = useProduct(({ product }) => ({ product }));
  const div = document.createElement("div");
  const pageContent = typeof settings?.page === "object" ? settings?.page?.content ?? "" : "";

  const [heading_namespace, heading_key] = settings.heading_metafield.split(".");
  const [content_namespace, content_key] = settings.content_metafield.split(".");
  const [image_namespace, image_key] = settings.image_metafield.split(".");
  const image = product?.metafields?.[image_namespace]?.[image_key];

  div.innerHTML = settings?.use_dynamic_content
    ? `${product?.metafields?.[heading_namespace]?.[heading_key] ?? ""}` || settings?.heading
    : settings?.heading;
  const title = div.textContent;

  div.innerHTML = settings?.use_dynamic_content
    ? image
      ? `${product?.metafields?.[content_namespace]?.[content_key] ?? ""}`
      : `${product?.metafields?.[content_namespace]?.[content_key] ?? ""}` ||
        settings?.content + pageContent
    : settings?.content + pageContent;
  const content =
    settings?.use_dynamic_content && image
      ? `${div.textContent}<img src="${image}" class="max-w-full relative w-full" />`
      : div.innerHTML;

  if (!title || !content) {
    return null;
  }

  return (
    <div className="grid border-b border-b-theme-text/50">
      <Accordion title={title} content={content} initOpen={!!settings.uncollapse} />
    </div>
  );
};
